export function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

export function rad2deg(rad) {
  return rad * (180 / Math.PI);
}

export function getDistance(from, to) {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(to.lat - from.lat); // deg2rad below
  const dLon = deg2rad(to.lng - from.lng);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(from.lat)) *
      Math.cos(deg2rad(to.lat)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  // Distance in km
  return R * c;
}

export function getBearing(begin, end) {
  const lat = Math.abs(begin.lat - end.lat);
  const lng = Math.abs(begin.lng - end.lng);

  if (begin.lat < end.lat && begin.lng < end.lng) {
    return parseFloat(rad2deg(Math.atan(lng / lat)));
  }
  if (begin.lat >= end.lat && begin.lng < end.lng) {
    return parseFloat(90 - rad2deg(Math.atan(lng / lat)) + 90);
  }
  if (begin.lat >= end.lat && begin.lng >= end.lng) {
    return parseFloat(rad2deg(Math.atan(lng / lat)) + 180);
  }
  if (begin.lat < end.lat && begin.lng >= end.lng) {
    return parseFloat(90 - rad2deg(Math.atan(lng / lat)) + 270);
  }
  return 0;
}

export function fromLatLngToPixel(map, position) {
  const { google } = window;
  const scale = 2 ** map.getZoom();
  const projection = map.getProjection();
  console.log(map, projection);
  const bounds = map.getBounds();
  const nw = projection.fromLatLngToPoint(
    new google.maps.LatLng(
      bounds.getNorthEast().lat(),
      bounds.getSouthWest().lng()
    ));
  const point = projection.fromLatLngToPoint(position);

  return new google.maps.Point(
    Math.floor((point.x - nw.x) * scale),
    Math.floor((point.y - nw.y) * scale));
}

export function fromPixelToLatLng(map, pixel) {
  const { google } = window;
  const scale = 2 ** map.getZoom();
  const projection = map.getProjection();
  const bounds = map.getBounds();

  const nw = projection.fromLatLngToPoint(
    new google.maps.LatLng(
      bounds.getNorthEast().lat(),
      bounds.getSouthWest().lng()
    ));
  const point = new google.maps.Point();

  point.x = pixel.x / scale + nw.x;
  point.y = pixel.y / scale + nw.y;

  return projection.fromPointToLatLng(point);
}

export function addOffsetToPixel(current, offset) {
  return {
    x: current.x + offset.x,
    y: current.y + offset.y,
  }
}
